export var SINGLE = 1;
export var EXPRESS = 2;
export var SYSTEM = 3;
export var ANTIEXPRESS = 5;



// WEBPACK FOOTER //
// ./src/constants/BetType.js